let host=process.env.VUE_APP_MYHOST
export const config = {
  morphHost: "http://udmcorpus.udman.ru", 
  apiUrl: host+'api/'
}